import withAemIntegration from "../../../../withAemIntegration";
import {
  ResponsiveGrid,
  withComponentMappingContext,
} from "@adobe/aem-react-editable-components";
import ComponentWrapper from "../../../component-wrapper";
import styled from "styled-components";

const ContainerEditConfig = {
  emptyLabel: "Tab Panel",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const ClearFix = styled.div`
  &:before,
  &:after {
    content: "";
    display: table;
  }
  &:after {
    clear: both;
  }
`;

const transformData = (props) => {
  const transformed = {
    ...props
  };
  return transformed;
};

export class Container extends ResponsiveGrid {
  render() {

    const data = transformData(this.props) ?? {};
    const { editorMode = false } = window;

    if (editorMode) {
      return (
      <ClearFix {...this.containerProps}>
        <div>{data.title}</div>
        <ComponentWrapper>{super.childComponents}</ComponentWrapper>
        {super.placeholderComponent}
      </ClearFix>
      );
    }

    return (
      <ClearFix {...this.containerProps}>
        <ComponentWrapper>{super.childComponents}</ComponentWrapper>
        {super.placeholderComponent}
      </ClearFix>
    );
  }
}

const ContainerComponent = withComponentMappingContext(Container);
ContainerComponent.displayName = "Tab Panel";

export default withAemIntegration(["lexus/components/content/content-tabs/tab-panel"])(
  ContainerComponent,
  ContainerEditConfig
);
